import styled from 'styled-components'

import * as spriteIcons from 'assets/svg/sprite'

interface DropdownButtonProps {
    toggleOpen: () => void
}
export function DropdownButton({ toggleOpen }: DropdownButtonProps) {
    return (
        <Button onClick={toggleOpen}>
            <spriteIcons.IconDownChevron />
        </Button>
    )
}

const Button = styled.button`
    background-color: #f1f1f1;
    padding: 0.9rem;
    border-radius: 1rem;
    border: 0;
    cursor: pointer;
`
